<template>
  <div :style="getStyle">
    <div v-if="value">
      <em class="fa fa-arrow-right"></em>
      <p style="font-size: 13px" class="mb-1">
        {{ totalRow }}
      </p>
      <em class="fa fa-arrow-down"></em>
      <p style="font-size: 13px">
        {{ totalColumn }}
      </p>
    </div>
  </div>
</template>
<script>
import { isset } from 'src/util/Util.js';

export default {
  name: 'cell-percentage',
  props: {
    value: {
      type: String | Number,
      default: 0,
    },
    totalRow: {
      type: String | Number,
      default: 0,
    },
    totalColumn: {
      type: String | Number,
      default: 0,
    },
  },
  computed: {
    getStyle() {
      if (!isset(this.value)) return '';
      return 'display: flex; align-items: center; justify-content: center';
    },
  },
};
</script>
